export const isCtrlOrCmdPressed = (event: React.MouseEvent<HTMLDivElement>) => {
  const uaData = navigator.userAgent;
  const isMac = uaData.includes('Mac');
  return isMac ? event.metaKey : event.ctrlKey;
}
